/**
 * Clase que representa la definicion de un elemento enumerado
 */
export class EnumDefinition
{
    id
    name
    stringValue
    description
    resumen
    
    constructor(id, name, stringValue, description, resumen)
    {
        this.id = id;
        this.name = name;
        this.stringValue = stringValue;
        this.description = description;
        this.resumen = resumen;
    }
}